export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 44 40" fill="none" className={className} aria-hidden="true">
    <path
      d="M25 5v20.5a7.5 7.5 0 0 1-15 0V23"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path d="M33 5v30" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    <path d="M41 12v9" stroke="#0052FF" strokeWidth="5" strokeLinecap="round" />
  </svg>
);

export const LogoLockup = ({ dark = false, className = "" }) => (
  <span className={`flex items-center gap-2.5 ${className}`}>
    <LogoMark className={`h-8 w-8 ${dark ? "text-white" : "text-ink"}`} />
    <span className="flex flex-col leading-none">
      <span className={`font-heading font-extrabold tracking-tight text-lg ${dark ? "text-white" : "text-ink"}`}>
        JISLL
      </span>
      <span className={`font-mono text-[9px] uppercase tracking-[0.22em] ${dark ? "text-slate-400" : "text-slate-500"}`}>
        Technology Services
      </span>
    </span>
  </span>
);
